<template>
  <div v-if="isVisible">
    <div v-if="showTitle" class="field__inner-title mb-3">
      <div>{{ schema.title }}</div>
      <p v-if="schema.help">{{ schema.help }}</p>
    </div>

    <v-menu
      v-model="datePickerModal"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290"
    >
      <template #activator="{ on }">
        <div v-on="isDisabled ? {} : on">
          <v-text-field
            :value="displayValue"
            :readonly="!schema.dateEditable"
            :disabled="isDisabled"
            :label="schema.title"
            :placeholder="fieldPlaceholder"
            :class="fieldClasses"
            :rules="rules"
            :clearable="!isDisabled"
            persistent-hint
            v-mask="'####-##-##'"
            @input="updateValue"
          />
        </div>
      </template>

      <v-date-picker
        :value="displayValue"
        color="primary"
        no-title
        :min="schema.min"
        :max="schema.max"
        @input="updateValue"
      />
    </v-menu>
  </div>
</template>

<script>
import GenericField from './GenericField';
import { mask } from 'vue-the-mask';
import { format, fromUnixTime, parseISO, getUnixTime } from 'date-fns';

const DATE_FORMAT = 'yyyy-MM-dd';

export default {
  name: 'DateField',
  mixins: [GenericField],
  directives: {
    mask,
  },
  data() {
    return {
      datePickerModal: false,
    };
  },
  computed: {
    fieldPlaceholder() {
      const { hideLabel, placeholder, label, dateEditable } = this.schema;
      if (hideLabel) return placeholder || label || 'YYYY-MM-DD';
      return dateEditable ? 'YYYY-MM-DD' : '';
    },

    displayValue() {
      if (!this.value) return null;

      if (this.isTimestamp(this.value)) {
        const seconds =
          this.value > 9999999999 ? Math.floor(this.value / 1000) : this.value;

        return format(fromUnixTime(seconds), DATE_FORMAT);
      }

      return this.value;
    },
  },
  methods: {
    isTimestamp(value) {
      const num = Number(value);
      return !isNaN(num) && num > 946684800;
    },

    updateValue(val) {
      this.datePickerModal = false;
      this.emitValue(this.normalizeOutput(val));
    },

    normalizeOutput(value) {
      if (!value) return value;

      if (this.isTimestamp(this.value)) {
        return getUnixTime(parseISO(value));
      }

      return value;
    },

    emitValue(value) {
      this.item ? this.save(value) : this.$emit('input', value);
    },
  },
};
</script>
